import React from 'react';

const STEPS = [
  { num: '01', icon: '🔍', title: 'Search Flights',  desc: 'Enter origin, destination, dates and passengers to see all options.',          color: 'bg-violet-100 text-violet-600 border-violet-200', accent: 'bg-violet-600' },
  { num: '02', icon: '🔀', title: 'Compare & Filter', desc: 'Sort by price, duration or departure. Filter non-stop vs connecting.',          color: 'bg-orange-100 text-orange-600 border-orange-200', accent: 'bg-orange-500' },
  { num: '03', icon: '📋', title: 'Enter Details',    desc: 'Fill in passenger info and contact details. Done in under 2 minutes.',          color: 'bg-emerald-100 text-emerald-600 border-emerald-200', accent: 'bg-emerald-500' },
  { num: '04', icon: '🎉', title: 'Confirmed!',       desc: "Get your booking ID and PNR instantly via email. You're ready to fly.",         color: 'bg-pink-100 text-pink-600 border-pink-200', accent: 'bg-pink-500' },
];

export default function HowItWorks() {
  return (
    <section className="bg-[#080c1a] py-16 sm:py-24 px-4">
      <div className="max-w-6xl mx-auto">

        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block bg-white/5 border border-white/10 text-orange-300 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-3 sm:mb-4">
            Simple Process
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-white">Book in 4 Easy Steps</h2>
          <p className="text-slate-500 mt-3 text-base sm:text-lg">From search to confirmation in under 3 minutes.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {STEPS.map((s, i) => (
            <div key={s.num} className="relative group">
              {i < STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(50%+40px)] right-[-50%] h-px bg-gradient-to-r from-white/10 to-transparent z-0" />
              )}
              <div className="relative z-10 bg-white/5 border border-white/8 rounded-2xl p-5 sm:p-6 hover:bg-white/8 hover:border-white/15 transition-all duration-300 h-full">
                <div className="flex items-center justify-between mb-4 sm:mb-5">
                  <div className={`w-12 h-12 sm:w-14 sm:h-14 rounded-2xl border-2 ${s.color} flex items-center justify-center text-xl sm:text-2xl`}>
                    {s.icon}
                  </div>
                  <span className="text-4xl sm:text-5xl font-black text-white/5 select-none">{s.num}</span>
                </div>
                <div className={`h-0.5 w-8 ${s.accent} rounded-full mb-3 sm:mb-4`} />
                <h3 className="font-bold text-white text-sm sm:text-base mb-2">{s.title}</h3>
                <p className="text-slate-500 text-xs sm:text-sm leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
